export default "__VITE_ASSET__CKJkEQ1C__"